<template>
  <div>
    <div class="content-wrap">
      <div class="content">
        Your data has been submitted successfully.<br />
        You may now close this window.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>

<style scoped>
div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.15em;
}
</style>
